module.exports = __webpack_public_path__ + "img/introduce_3.e1b2b331.png";